import { EConsultantChatActionTypes, TConsultantChatActions } from '../../actions/consultantChat';
import { IConsultantChat } from '../../types/redux/consultantChat';

const initialState = {
  isOpen: false,
};

export const consultantChatReducer = (state: IConsultantChat = initialState, action: TConsultantChatActions) => {
  switch (action.type) {
    case EConsultantChatActionTypes.ToggleOpen:
      return {
        isOpen: action.payload,
      };
    default:
      return state;
  }
};
